document.addEventListener("DOMContentLoaded", function () {
    const mobileMenuButton = document.getElementById("mobile-toggle");
    const mobileMenu = document.getElementById("mobile-nav-menu");
    const mobileShadow = document.getElementById("mobile-shadow");

    if (mobileMenuButton && mobileMenu) {
        mobileMenuButton.addEventListener("click", () => {
            mobileMenu.classList.toggle("open");
            mobileMenuButton.classList.toggle("open");
            mobileShadow?.classList.toggle("open");
        });

        if (mobileShadow) {
            mobileShadow.addEventListener("click", () => {
                mobileMenu.classList.remove("open");
                mobileMenuButton.classList.remove("open");
                mobileShadow.classList.remove("open");
            });
        }
    }

    // Expand/collapse submenus in mobile
    document.querySelectorAll(".mobile-menu-wrapper > div").forEach((item) => {
        const submenu = item.querySelector("ul");
        const link = item.querySelector("a");

        if (submenu && link) {
            link.addEventListener("click", (e) => {
                e.preventDefault(); // Prevent navigation
                item.classList.toggle("open");
            });
        }
    });
});

const nav = document.getElementById("shopify-section-header");
const trigger = document.getElementById("nav-trigger");

if (nav && trigger) {
    const observer = new IntersectionObserver(
        ([entry]) => {
            nav.classList.toggle("nav-scrolled", !entry.isIntersecting);
        },
        { threshold: 0 }
    );

    observer.observe(trigger);
}
